function fnc_readmore() {
  const $CONTAINERS = $('.block-readmore');
  if ($CONTAINERS.length > 0) {
    $CONTAINERS.each(function () {
      const $TEXT = $(this).children('.block-readmore_txt');
      const $BTN = $(this).children('.block-readmore_btn');
      const HEIGHT = $(this).children('.block-readmore_txt').innerHeight();
      const LINE_HEIGHT = parseFloat($TEXT.css('line-height'));
      if (HEIGHT < LINE_HEIGHT * 2) {
        $BTN.hide();
      } else {
        _fnc_close($TEXT, $BTN, LINE_HEIGHT);

        $BTN.on('click', function (e) {
          e.preventDefault();
          if ($(this).hasClass('is-open')) {
            _fnc_close($TEXT, $BTN, LINE_HEIGHT);
          } else {
            _fnc_open($TEXT, $BTN, HEIGHT);
          }
        });
      }
    });
  }
}
function fnc_accordion() {
  const $ACCO_BTN = $('.js-accordion-btn');
  if ($ACCO_BTN.length > 0) {
    $ACCO_BTN.each(function () {
      $(this).on('click', function (e) {
          e.preventDefault();
          if ($(this).hasClass('is-active')) {
           $(this).removeClass('is-active');
            $(this).next('.js-accordion-body').slideUp();
          } else {
            $(this).addClass('is-active');
            $(this).next('.js-accordion-body').slideDown();
          }
        });
    });
  }
}
function _fnc_close(container, btn, lineheight) {
  container.css({ maxHeight: lineheight * 3 });
  btn.removeClass('is-open');
  setTimeout(() => {
    container.addClass('is-close');
  }, 500);
}
function _fnc_open(container, btn, height) {
  container.css({ maxHeight: height }).removeClass('is-close');
  btn.addClass('is-open');
}

function fnc_productTab() {
  const $TAB_NAVIGATION = $('.js-tab-navigation');
  if ($TAB_NAVIGATION.length > 0) {
    $TAB_NAVIGATION.each(function () {
      const TAB_TARGET_GROUP_ID = $TAB_NAVIGATION.data('tab-group-id');
      const $TAB_TARGET_GROUP = $(
        `.${TAB_TARGET_GROUP_ID}`
      );
      const $BTNS = $(this).children('.tab-navigation-btn');

      $TAB_TARGET_GROUP.hide();
      $TAB_TARGET_GROUP.eq(0).show();
      $BTNS.eq(0).addClass('is-active');

      $BTNS.each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();
          const TAB_TARGET_ID = $(this).data('target');
          const $TAB_TARGET = $(`#${TAB_TARGET_ID}`);
          if ($(this).hasClass('is-active')) {
            return;
          } else {
            $BTNS.removeClass('is-active');
            $(this).addClass('is-active');
            $TAB_TARGET_GROUP.hide();
            $TAB_TARGET.show();
          }
        });
      });
    });
  }
}

function fnc_footerGuide() {
  const $CONTAINER = $('#js-footer_guide');
  if ($CONTAINER.length > 0) {
     console.log($CONTAINER.children('dt'));
      $CONTAINER.children('dt').on('click', function (e) {
        console.log('bb');
        e.preventDefault();
        if ($(this).hasClass('is-active')) {
          $(this).next().slideUp();
          $(this).removeClass('is-active');
        } else {
          $(this).next().slideDown();
          $(this).addClass('is-active');
        }
      });
  }
}

$(function () {
  fnc_accordion();
  fnc_readmore();
  fnc_productTab();
  fnc_footerGuide();
});
